import { useSiteConfig } from "@/hooks/useSiteConfig";
import { Reveal, SectionHeader } from "./primitives";

const TokenSpecs = () => {
  const config = useSiteConfig();
  return (
    <section className="relative py-24 lg:py-32 border-t border-line" data-testid="token-specs-section">
      <div className="section-shell grid gap-12 lg:grid-cols-[1fr_1.4fr] lg:gap-20 items-start">
        <SectionHeader
          index={2}
          eyebrow="Token Specifications"
          title={<>Technical<br />Specification</>}
          sub="The complete on-chain identity of Jovino Coin. Deployed once. Fixed forever."
          testId="token-specs-header"
        />
        <Reveal delay={0.1}>
          <dl className="card-surface rounded-xl overflow-hidden divide-y divide-line" data-testid="token-specs-table">
            {config.specifications.map(([k, v]) => (
              <div key={k} className="flex items-center justify-between gap-6 px-6 sm:px-8 py-4 sm:py-5">
                <dt className="font-mono text-[11px] sm:text-xs tracking-[0.2em] uppercase text-slate shrink-0">{k}</dt>
                <dd
                  className={`font-mono text-sm sm:text-base text-right ${
                    k === "Maximum Supply" ? "text-gold font-semibold" : "text-mist"
                  }`}
                >
                  {v}
                </dd>
              </div>
            ))}
            <div className="flex items-center justify-between gap-6 px-6 sm:px-8 py-4 sm:py-5">
              <dt className="font-mono text-[11px] sm:text-xs tracking-[0.2em] uppercase text-slate shrink-0">Contract Address</dt>
              <dd className="font-mono text-sm sm:text-base text-right text-slate" data-testid="contract-address-value">
                To Be Announced
              </dd>
            </div>
          </dl>
        </Reveal>
      </div>
    </section>
  );
};

export default TokenSpecs;
